import { AlertsPage } from "@client/features/alerts/AlertsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/alerty")({
  component: AlertsPage,
});
